// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"93395b4b","827":"7e7c9210"}[chunkId] + ".chunk.css";
};